import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';
import { spaLoad } from 'components/spa-load';

export default class LiveTabs extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.checkIfItemIsSelected();

        if (this.refs.link) {
            this.refs.link.forEach((link) => {
                this.addListener(link, 'click', this.onLinkClick);
            });
        }
    }

    checkIfItemIsSelected = () => {
        if (!this.refs.link) return;

        this.clearSelection(this.refs.link);

        this.refs.link.forEach((link) => {
            if (link.getAttribute('href') === window.location.pathname) {
                link.classList.add('is-active');
            } else if (this.getAttribute(link, 'aliases')) {
                const aliases = JSON.parse(this.getAttribute(link, 'aliases'));
                Object.values(aliases).forEach((alias) => {
                    if (window.location.pathname.includes(alias)) {
                        link.classList.add('is-active');
                    }
                });
            }
        });
    };

    clearSelection(nodesArray) {
        nodesArray.forEach((node) => {
            if (node.classList.contains('is-active')) {
                node.classList.remove('is-active');
            }
        });
    }

    onLinkClick = (event) => {
        const ignoreSpa = event.currentTarget.getAttribute('data-ignore-spa') === 'true';
        if (!ignoreSpa) {
            if (!app.isEditMode) {
                spaLoad.updateContent(event.currentTarget.href);
            }
            event.preventDefault();

            const aliasToFocus = event.currentTarget.getAttribute('href');

            const links = document.querySelectorAll('a[data-dc-live-navigation-aliases]');
            if (links.length > 0) {
                links.forEach((link) => {
                    const rawAliases = link.getAttribute('data-dc-live-navigation-aliases');
                    try {
                        const aliases = JSON.parse(rawAliases);
                        if (aliases.some((alias) => alias.includes(aliasToFocus))) {
                            link.focus();
                            link.classList.add('is-active');
                            const liveNavigationSelector = document.querySelector('[data-dc-live-navigation-ref="selector"]');
                            liveNavigationSelector.style.left = this.calculateSelectorPosition(link, liveNavigationSelector);
                            liveNavigationSelector.classList.add('is-visible');
                        } else {
                            link.classList.remove('is-active');
                        }
                    } catch (e) {
                        console.log('Error on live tabs click ', e);
                    }
                });
            }

            const linksMobile = document.querySelectorAll('a[data-dc-live-submenu-aliases]');
            if (linksMobile.length > 0) {
                linksMobile.forEach((link) => {
                    const rawAliases = link.getAttribute('data-dc-live-submenu-aliases');
                    try {
                        const aliases = JSON.parse(rawAliases);
                        if (aliases.some((alias) => alias.includes(aliasToFocus))) {
                            link.focus();
                            link.classList.add('is-active');
                        } else {
                            link.classList.remove('is-active');
                        }
                    } catch (e) {
                        console.log('Error on live tabs click on mobile ', e);
                    }
                });
            }
        }
    }

    calculateSelectorPosition(item, liveNavigationSelector) {
        const liveHeader = document.querySelector('[data-dc-component="live-navigation"]');
        const itemWidth = item.clientWidth;
        const navigationCoords = liveHeader.getBoundingClientRect();
        const itemCoords = item.getBoundingClientRect();
        const itemPosition = itemCoords.left - navigationCoords.left;
        const selectorWidth = liveNavigationSelector.clientWidth;

        return itemPosition + (itemWidth / 2) - (selectorWidth / 2) + 'px';
    }
}
